import { useEffect } from "react";

export default function ChildSafetyPolicy() {
  useEffect(() => {
    document.title = "Hunt Share Live – Child Safety Standards";
  }, []);

  return (
    <section className="px-6 py-16 text-white md:px-8 lg:px-16">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8 text-center">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-orange-300">Hunt Share Live</p>
          <h1 className="text-3xl font-black tracking-tight text-white md:text-5xl">
            Hunt Share Live – Child Safety Standards
          </h1>
        </div>

        <div className="rounded-[2rem] border border-white/10 bg-slate-950/70 p-6 shadow-[0_25px_70px_rgba(0,0,0,0.35)] backdrop-blur-sm md:p-10 lg:p-12">
          <div className="space-y-8 text-slate-200">
            <p className="text-base leading-8 text-slate-300">
              Hunt Share Live is committed to creating a safe, respectful, and lawful online environment for all
              users. Protecting children and preventing harm is a core responsibility of the platform.
            </p>

            <div className="rounded-2xl border border-orange-500/30 bg-orange-500/5 p-5">
              <h2 className="mb-3 text-xl font-bold text-orange-300">Zero Tolerance</h2>
              <p className="text-base leading-8 text-slate-200">
                Hunt Share Live has ZERO TOLERANCE for:<br />
                • Child Sexual Abuse and Exploitation (CSAE)<br />
                • Child Sexual Abuse Material (CSAM)<br />
                • Child exploitation<br />
                • Child grooming<br />
                • Sexualization of minors
              </p>
            </div>

            <div>
              <h2 className="mb-3 text-xl font-bold text-white">Prohibited Content and Activity</h2>
              <p className="text-base leading-8 text-slate-300">
                Users are strictly prohibited from creating, uploading, sharing, requesting, distributing, or
                facilitating any CSAE or CSAM content or activity on Hunt Share Live. This includes any content,
                communication, behavior, or coordination that exploits, endangers, seeks to exploit, or sexualizes a
                minor. Any such activity is unacceptable and will be treated as a serious violation.
              </p>
            </div>

            <div>
              <h2 className="mb-3 text-xl font-bold text-white">Enforcement and Response</h2>
              <p className="text-base leading-8 text-slate-300">
                Hunt Share Live may, at its sole discretion and when appropriate, remove violating content, suspend or
                terminate accounts, investigate reports, preserve relevant information, and report suspected illegal child
                exploitation to the appropriate authorities when required by law or when necessary to protect minors and
                support lawful investigations.
              </p>
            </div>

            <div className="rounded-2xl border border-white/10 bg-slate-900/80 p-5">
              <h2 className="mb-3 text-xl font-bold text-white">How to Report Child Safety Concerns</h2>
              <p className="text-base leading-8 text-slate-300">
                If you suspect child sexual abuse, exploitation, grooming, or CSAM, please report it immediately by
                contacting Hunt Share Live at:<br />
                <strong>Email:</strong> info@huntsharelive.com
              </p>
            </div>

            <div className="rounded-2xl border border-white/10 bg-slate-900/80 p-5">
              <h2 className="mb-3 text-xl font-bold text-white">Child Safety Contact</h2>
              <p className="text-base leading-8 text-slate-300">
                <strong>Email:</strong> info@huntsharelive.com
              </p>
            </div>

            <div>
              <h2 className="mb-3 text-xl font-bold text-white">General Safety Commitments</h2>
              <p className="text-base leading-8 text-slate-300">
                Hunt Share Live takes child safety seriously and may investigate reports, act quickly to remove harmful
                content, and cooperate with relevant stakeholders when legally required. We are committed to minimizing
                harm and protecting minors across our platform.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
